export enum UserFeatures {
  // [Obsolete("This feature is obsolete and should not be used")]
  CognosReports = 1,
  Reports = 2,
  // [Obsolete("This feature is obsolete and should not be used")]
  EgiReports = 3,
  Graphs = 4,
  OrderFeed = 5,
  OrderRead = 6,
  ApiProducts = 8,
  ApiOrders = 9,
  ApiSilo = 10,
  ApiKpi = 11,

  // [Obsolete("This feature is obsolete and should not be used")]
  PowerBi = 12,

  // Full access for P&P - planning, read access for P&P - profiles and feed strategies
  PlanningPrognosis = 13,
  FieldRegistration = 14,

  FjordfrendeApiAccess = 15,

  AdminCompanyAccess = 16,
  AdminMarketAccess = 17,
  GrantOrRevokeAnyRole = 18,
  GrantOrRevokeNonSensitiveRole = 19,
  AdminGlobalFeatures = 20,
  AdminListUsers = 21,

  ReadAllUsers = 22,
  ReadMarketAndGlobalUsers = 23,
  ManageAllUsers = 24,
  ManageMarketUsers = 25,
  ManageMarketAndGlobalUsers = 26,

  ReadAllCustomers = 27,
  ReadMyMarketCustomers = 28,
  ReadMyCustomers = 29,
  ManageAllCustomers = 30,
  ManageMyMarketCustomers = 31,
  ManageMyCustomers = 32,

  ReadAllRoles = 33,
  ReadMyMarketRoles = 34,
  ReadMyMarketAndGlobalRoles = 35,
  ManageAllRoles = 36,
  ManageMyMarketRoles = 37,
  ManageMyMarketAndGlobalRoles = 38,

  ReadAllGroups = 39,
  ReadMyMarketGroups = 40,
  ReadMyMarketAndGlobalGroups = 41,
  ManageAllGroups = 42,
  ManageMyMarketGroups = 43,
  ManageMarketAndGlobalGroups = 44,

  CreateServiceAccounts = 45,

  ReadAdminRoles = 46,
  ManageAdminRoles = 47,

  AccessSeaCloudMappings = 48,

  AdminCanExportUsersAndRights = 49,

  // [Obsolete("This feature is obsolete and should not be used")]
  UmbracoApiAccess = 50,
  SeaCloudApiAccess = 51,
  ProfilesAndStrategiesManageMarketProfiles = 52,
  ProfilesAndStrategiesManageCompanyOrSiteProfiles = 53,

  PriceLists = 54,
  PriceListsAdministrator = 55,

  SalmonReviewPowerBireports = 56,
  SalmonManagePowerBireports = 57,

  // Does not allow updating site settings and fishgroup planning, creating virtual fishgroups, creating snapshots
  PlanningPrognosisReadonly = 58,

  SalmoNir = 59,

  ProfilesAndStrategiesReadonly = 60,

  FishQuality = 61,

  SalmoNirApplicationManager = 62,

  UploadFilesToSeaCloud = 63,

  ReadAllSuppliers = 65,
  ReadMyMarketSuppliers = 66,
  ReadMySuppliers = 67,
  ManageAllSuppliers = 68,
  ManageMyMarketSuppliers = 69,
  ManageMySuppliers = 70,

  /// <summary>
  /// Access to a page that displays a graph with both temperature and oxygen level for the selected site
  /// </summary>
  // [Obsolete("This feature is obsolete and should not be used")]
  FunnData = 71,

  SourcingData = 72,

  PlanningPrognosisForecast = 73,

  ManageOrderSettings = 74,

  OrderFreeDelivery = 75,

  AssignSiteResponsibility = 76,

  FishPoolDataApiAccess = 77,

  ScenarioBuilder = 78,
  ScenarioRunnerApiAccess = 80,

  ManageShippingRoutes = 81,
  ApiSustainability = 82,

  SiteSettingsRead = 83,
  SiteSettingsWrite = 84,
  Nutritionist = 86,

  // FormulationCostRead = 87, This feature is obsolete and should not be used. Was replaced by the Nutritionist feature.
  // FormulationCostWrite = 88, This feature is obsolete and should not be used. Was replaced by the Nutritionist feature.

  FeedProgramPlanner = 89,
  BenchmarkDataApiAccess = 90,
  ShippingScheduleApiAccess = 91,

  ShrimpReviewPowerBireports = 92,
  ShrimpManagePowerBireports = 93,

  ReportingDataReader = 94,

  FileSharingAudit = 95,
  FileSharingManage = 96,

  ImageCarouselEditor = 97,
  ApiOrderDeDp = 98,

  ShrimpsProductionSystem = 99,
  ShrimpsProductionSystemApi = 100,

  AnteoShipmentApiAccess = 101,
  ShipmentEtaReadApiAccess = 102,
  QualityMetricApiAccess = 103,

  SustainabilityFeedApiAccess = 104,

  ManageMarketContacts = 105,

  OrderManagementOverview = 106,

  /// <summary>
  /// A user needs to have this feature assigned (via a role), in order to have access to SeaCloud production data
  /// </summary>
  SeaCloudProductionDataAccess = 107,
  OrderFreeDelivery2 = 108,
  ShrimpDataUpload = 109,
  /// <summary>
  /// Enables users to manage Feeders and Aerators for Shrimp sites
  /// </summary>
  FarmSetup = 110,
  /// <summary>
  /// Allows users to manage self-service menu access on shrimp sites.
  /// </summary>
  SelfService = 111,
  ShrimpBenchmarkAnalytics = 112,
}
